/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from '@polleverywhere/backbone'
import Segment from './segment'

export default class Segments extends Backbone.Collection {
  get model () { return Segment }

  responseCount (opts) {
    if (opts == null) { opts = {} }
    return this.segmentingOption.responseCount(opts)
  }

  maxResponseCount (opts) {
    if (opts == null) { opts = {} }
    return this.segmentingOption.maxResponseCount(opts)
  }
}
